import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
interface BenefitsProps {
  onCTAClick?: () => void;
}
export function Benefits({
  onCTAClick
}: BenefitsProps) {
  return <section className="py-16 md:py-24 bg-white pt-[10px] pb-[10px]" data-id="element-18">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-20">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-6 text-[#1F3A5F] font-oswald uppercase tracking-wide" data-id="element-21">
            🚀 EL RECURSO QUE TODO DOCENTE NECESITA
          </h2>
          <p className="text-xl md:text-2xl text-center mb-4 text-gray-600 font-playfair italic" data-id="element-22">
            Este no es un simple manual.
          </p>
          <p className="text-xl md:text-2xl text-center mb-12 font-semibold text-[#1F3A5F]" data-id="element-23">
            Es un sistema académico completo diseñado específicamente para
            docentes de secundaria de Argentina.
          </p>

          <div className="bg-[#FAF7F2] rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100" data-id="element-24">
            <p className="text-xl text-center mb-8 font-medium text-gray-700" data-id="element-25">
              Un producto creado para:
            </p>
            <div className="grid md:grid-cols-2 gap-4 max-w-3xl mx-auto" data-id="element-26">
              {['ahorrar tiempo real,', 'organizar mejor las clases,', 'facilitar explicaciones,', 'modernizar el aula,', 'y darle al docente TODO listo para usar.'].map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-sm border border-gray-50" data-id="element-27">
                  <CheckCircle2 className="text-[#2D6A4F] flex-shrink-0" size={24} data-id="element-28" />
                  <span className="text-lg text-gray-800 font-medium" data-id="element-29">
                    {item}
                  </span>
                </motion.div>)}
            </div>

            {onCTAClick && <div className="text-center mt-10" data-id="element-30">
                <button onClick={onCTAClick} className="bg-[#2D6A4F] hover:bg-[#1B4332] text-white text-lg md:text-xl font-bold py-4 px-8 md:px-12 rounded-xl shadow-lg transform hover:scale-105 transition-all inline-flex items-center justify-center gap-3" data-id="element-31">
                  EMPEZAR A AHORRAR TIEMPO HOY
                </button>
              </div>}
          </div>
        </motion.div>
      </div>
    </section>;
}